import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SessionManagerService } from '../services/session-manager.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private sessionManager: SessionManagerService, private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.sessionManager.loggedIn) {
      request = request.clone({
        setHeaders: {
          'Authorization': `Token ${this.sessionManager.token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        if (response.status === 401) {
          this.sessionManager.clearSessionData();
          this.router.navigate(['login'])
        }
        return throwError(response);
      }
      ));
  }
}
